import { createDraftSafeSelector } from "@reduxjs/toolkit"

export const contactosSelector = (state: $TSMigrationFixMe) => {
  return state.contacto
}

export const getContactosSelector = createDraftSafeSelector(
  contactosSelector,
  (state) => state.contactos
)

export const getContactoSelector = createDraftSafeSelector(
  contactosSelector,
  (state) => state.contacto
)

export const getAllContactosSelector = createDraftSafeSelector(
  contactosSelector,
  (state) => state.allContactos
)

export const getAllContactosOptionsSelector = createDraftSafeSelector(
  getAllContactosSelector,
  (allContactos) => {
    return allContactos.map((contacto: $TSMigrationFixMe) => ({
      label: contacto.razonSocial,
      value: contacto,
    }))
  }
)
export const getContactosBySelectSelector = createDraftSafeSelector(
  contactosSelector,
  ({ contactosBySelect }) =>
    contactosBySelect?.map((contacto: $TSMigrationFixMe) => ({
      label: contacto.razonSocial,
      value: contacto,
    }))
)

export const getRazonSocial = (state: $TSMigrationFixMe) =>
  state.empresa.razonSocial
export const getContactoById = (state: $TSMigrationFixMe) => state.contacto
